import { GET_TERMS } from '~/constants/APIs/termsofservice'

import axiosClient from './axiosClient'

export const termsofserviceApi = {
  getAll: () => axiosClient.get(GET_TERMS) as unknown as string,
  accept: () => axiosClient.post(GET_TERMS)
}
